import prescriptionDetails from 'common/constants/prescriptionDetails';

/**
 * POM-6305 — the label in front of one entry of a rejected order's `reasons` slot.
 *
 * A prescription field error keeps its field ("Strength: Invalid strength"). An order-acceptance
 * rejection arrives under `orderRejection` and reads as the "Reason". A key the portal has no label
 * for is shown as a Reason too, so it never renders as "undefined: …".
 */
const getRejectionReasonLabel = (key) =>
  prescriptionDetails[key] || prescriptionDetails.orderRejection;

export default getRejectionReasonLabel;
